import 'antd-mobile/bundle/css-vars-patch.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import useDevTool from './hooks/useDevTool';
import useServiceWork from './hooks/useServiceWork';
import './index.scss';
import Index from './pages/Index';

//import reportWebVitals from './reportWebVitals';
//declare var __webpack_public_path__: string;

useDevTool()
useServiceWork()
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
